<template>
  <v-dialog
    :value="show"
    max-width="700px"
    @input="closeModal">
      <v-text-field
        solo
        class="search-chat"
        placeholder="Busqueda"
        v-model="search"
        append-icon="fa-search"
        :append-icon-cb="clearSearch"
        @keypress.enter.exact.prevent="applySearch"></v-text-field>
  </v-dialog>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    searched: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      search: '',
    };
  },
  methods: {
    closeModal(value) {
      if (!value) {
        this.$emit('close');
      }
    },
    applySearch() {
      this.$emit('search', this.search);
    },
    clearSearch() {
      if (this.search !== '' || this.searched !== '') {
        this.applySearch();
      } else {
        this.closeModal();
      }
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.search = this.searched;
      }
    },
  },
};
</script>
<style scoped>
  .search-chat >>> input {
    color: #333333;
    height: 60px;
    font-size: 40px;
  }
  .search-chat >>> input::input-placeholder {
    font-size: 40px;
  }
  .input-group--focused >>> input {
    caret-color: black !important;
  }
  .input-group--focused >>> .fa {
    color: black !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/chat_center_v2/SearchModal.vue